import React, { Component } from "react";
import { NavLink, withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import "./navbar.css";
import AvailabilitySwitch from "./availabilitySwitch";
import { toastTheError, toastMessage } from "../services/toastService";
import { getVisioPending } from "../services/apiService";
import { trackEvent } from "../services/analyticsService";
import { changeTheme } from "../store/actions";
import {
  Header,
  HeaderName,
  HeaderGlobalAction,
  HeaderGlobalBar,
  HeaderNavigation,
  HeaderMenuButton,
  SideNav,
  SideNavItems,
  SideNavLink,
  SideNavMenu,
  SideNavMenuItem
} from "carbon-components-react/lib/components/UIShell";

class Navbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      remaining: 0,
      sideNavExpanded: false
    };

    const self = this;
    document.addEventListener("availabiltyChanged", function(e) {
      if (e.detail) {
        //self.getTotalPendingCount();
      } else {
        self.setState({
          remaining: 0
        });
      }
    });

    this.logout = this.logout.bind(this);
    this.getTotalPendingCount = this.getTotalPendingCount.bind(this);
  }

  componentDidMount() {
    this.getTotalPendingCount();
  }

  logout() {
    try {
      trackEvent("Logout", "Clicked");
      localStorage.clear();
      //toastMessage("Logout Successful");
      this.props.history.push("/");
    } catch (error) {
      toastTheError(error);
    }
  }

  getTotalPendingCount() {
    const self = this;
    /*getVisioPending().then((data) => {
      self.setState({
        remaining: data.total_pending
      });
    });*/
  }

  changeThemeCallback() {
    this.props.changeTheme(this.props.theme == "dark" ? "" : "dark");
  }

  render() {
    const { t } = this.props;
    return (
      <Header aria-label="IBM Platform Name">
        <HeaderMenuButton
          aria-label="Open menu"
          onClick={() => {
            const newVal = !this.state.sideNavExpanded;
            this.setState({
              sideNavExpanded: newVal
            });
          }}
          isActive={this.state.sideNavExpanded}
        />
        <HeaderName href="#" prefix="Kunduz">
          Visio
        </HeaderName>
        <HeaderNavigation aria-label="IBM [Platform]">
          {this.props.teacher.can_review_question ? (
            <li>
              <NavLink
                activeClassName="selected"
                className="bx--header__menu-item"
                to="/questionMatch"
                role="menuitem"
              >
                {t("questionMatch")}
              </NavLink>
            </li>
          ) : (
            <></>
          )}

          {this.props.teacher.can_review_answer ? (
            <li>
              <NavLink
                activeClassName="selected"
                className="bx--header__menu-item"
                to="/answerMatch"
                role="menuitem"
              >
                {t("answerMatch")}
              </NavLink>
            </li>
          ) : (
            <></>
          )}
          <li>
            <NavLink
              activeClassName="selected"
              className="bx--header__menu-item"
              to="/stats"
              role="menuitem"
            >
              {t("stats")}
            </NavLink>
          </li>
          {/*<HeaderMenu aria-label="Link 4" menuLinkName="Link 4">
            <HeaderMenuItem href="#">Sub-link 1</HeaderMenuItem>
            <HeaderMenuItem href="#">Sub-link 2</HeaderMenuItem>
            <HeaderMenuItem href="#">Sub-link 3</HeaderMenuItem>
    </HeaderMenu>*/}
        </HeaderNavigation>
        <HeaderGlobalBar>
          <HeaderGlobalAction aria-label="Availability" onClick={() => {}}>
            <AvailabilitySwitch />
          </HeaderGlobalAction>
          <HeaderGlobalAction
            aria-label="Theme"
            title="Theme"
            onClick={() => {
              this.changeThemeCallback();
            }}
          >
            <i
              className={`${
                this.props.theme == "dark"
                  ? "far fa-lightbulb"
                  : "fas fa-lightbulb"
              }`}
              style={{ color: "#FFF" }}
            ></i>
          </HeaderGlobalAction>
          <HeaderGlobalAction
            aria-label="Logout"
            title="Logout"
            onClick={() => {
              this.logout();
            }}
          >
            <i className="fas fa-sign-out-alt" style={{ color: "#FFF" }} />
          </HeaderGlobalAction>
        </HeaderGlobalBar>
        <SideNav
          aria-label="Side navigation"
          expanded={this.state.sideNavExpanded}
          isPersistent={false}
        >
          <SideNavItems>
            {this.props.teacher.can_review_question && (
              <li className="bx--side-nav__item">
                <NavLink
                  activeClassName="selected"
                  className="bx--side-nav__link"
                  to="/questionMatch"
                  role="menuitem"
                >
                  <span className="bx--side-nav__link-text">
                    {t("questionMatch")}
                  </span>
                </NavLink>
              </li>
            )}
            {this.props.teacher.can_review_answer && (
              <li className="bx--side-nav__item">
                <NavLink
                  activeClassName="selected"
                  className="bx--side-nav__link"
                  to="/answerMatch"
                  role="menuitem"
                >
                  <span className="bx--side-nav__link-text">
                    {t("answerMatch")}
                  </span>
                </NavLink>
              </li>
            )}
            <li className="bx--side-nav__item">
              <NavLink
                activeClassName="selected"
                className="bx--side-nav__link"
                to="/stats"
                role="menuitem"
              >
                <span className="bx--side-nav__link-text">{t("stats")}</span>
              </NavLink>
            </li>
          </SideNavItems>
        </SideNav>
      </Header>
    );
  }
}

const mapStateToProps = (state /*, ownProps*/) => {
  return {
    teacher: state.teacher,
    theme: state.theme
  };
};

const mapDispatchToProps = { changeTheme };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withTranslation("kunduz")(Navbar)));
